import { ERROR, IS_LOADING } from "../../constants";

export { ERROR, IS_LOADING };

export const LOAD_WORK_ORDERS = "LOAD_WORK_ORDERS";

export const SYNCHRO_GET_API_WORK_ORDERS = "SYNCHRO_GET_API_WORK_ORDERS";
